const initialState = {
  orderDetail: {},
  exchangePoint: [],
};

// 订单详情
export default function receiveOrderDetailDate(state = initialState, action) {
  switch (action.type) {
  case 'ORDER_DETAIL':
    return { ...state, orderDetail: action.payload };
  case 'GET_EXCHANGE_POINT':
    return { ...state, exchangePoint: action.payload };
  default:
    return state;
  }
}